import classNames from 'classnames';
import React from 'react';

import type { ToolbarButtons } from '../../../models';
import { FloatingToolbar } from '../../FloatingToolbar/FloatingToolbar';
import { OverflownButtonsToolbar } from './data-hooks';
import styles from './OverflownButtons-scss';

export const OverflownButtons = ({
  type,
  shouldShowMore,
  overflownButtons,
  showMoreAbove,
  attachTo,
}: {
  type: 'floating' | 'static' | 'regular';
  shouldShowMore: boolean;
  overflownButtons: ToolbarButtons;
  showMoreAbove: boolean;
  attachTo: HTMLButtonElement;
}) => {
  const showOverflowButtons = shouldShowMore && !overflownButtons.isEmpty() && !!attachTo;

  if (!showOverflowButtons) {
    return null;
  }

  const renderVertical = showMoreAbove ? 'top' : 'bottom';

  return (
    <FloatingToolbar
      hideStrategy="referenceHidden"
      referenceElement={attachTo}
      boundary={document.body}
      placement={`${renderVertical}-start`}
    >
      <div
        className={classNames(styles.moreItems, {
          [styles.moreItemsFloating]: type === 'floating',
          [styles.moreItemsStatic]: type === 'static',
        })}
        data-hook={OverflownButtonsToolbar}
      >
        <div className={styles.overflownItems}>
          {overflownButtons.getButtonsElementsWithDataHook()}
        </div>
      </div>
    </FloatingToolbar>
  );
};
